import { ApiResponse, TokenData, LeadType } from '../models';
import * as http from './http';
import ApiService from './service';

export class LeadTypeService extends ApiService {
  public async loadAllLeadType() {
    const url = `${this.apiDomain}/api/lead-type`;

    const resposne = await http.get<ApiResponse<LeadType[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateLeadType(data: LeadType, id?: string) {
    const url = `${this.apiDomain}/api/lead-type/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createLeadType(data: LeadType) {
    const url = `${this.apiDomain}/api/lead-type`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteLeadType(id?: string) {
    const url = `${this.apiDomain}/api/lead-type/${id}`;

    const response = await http.remove<ApiResponse<LeadType>>(url, this.store);
    return response.data;
  }
}
